import { InfoCircleOutlined } from '@ant-design/icons';
import get from 'lodash/get';
import { closeChecklistURLs } from 'routes/close/closeURLs';
import { colors } from 'theme/colors';

import { Avatar } from 'components/data-display/Avatar';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';
import { getDueDateText } from 'layout/inbox-notifications/close/_closeNotificationUtils';

import type { TaskOverdueNotification } from 'types/inbox-notifications/close/ChecklistNotifications';

export function OverdueNotificationItem({
  item,
}: {
  item: TaskOverdueNotification;
}) {
  if (!item.task) {
    return <div>Notification task not found</div>;
  }

  const overdueAt = getDueDateText(
    get(item.task, item.assignee_field)?.due_date_time
  );

  return (
    <GenericNotificationItem
      item={item}
      url={closeChecklistURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={
        <Avatar
          style={{
            backgroundColor: colors.colorErrorBg,
            borderColor: colors.colorErrorBgHover,
            color: colors.colorErrorText,
            fontSize: 10,
            paddingTop: 1,
          }}
        >
          <InfoCircleOutlined />
        </Avatar>
      }
      title={`Your task is overdue`}
      description={
        <>
          <span>&quot;{item.task.core_snapshot.name}&quot;</span>
          <span> was due </span>
          <span style={{ color: colors.colorError }}>{overdueAt}</span>
          <span>, please update status.</span>
        </>
      }
    />
  );
}
